import ReactGA from 'react-ga4';
import { Result } from '@hitiq/generic';
import { Logger, LogType } from '@hitiq/logger';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { Persistance } from '../../dataStorePersistence/persistence';
import { Translator } from '../translator.interface';
import { Account, AccountBackend } from './accounts.interfaces';

export const createAccountsThunk = createAsyncThunk(
  'accounts/createAccounts',
  async (
    payload: {
      translator: Translator<AccountBackend, Account>;
      persistence: Persistance<AccountBackend>;
      loggingService: Logger;
      account: Account;
    },
    thunkAPI,
  ): Promise<any> => {
    const { persistence, translator, account, loggingService } = payload;

    const backendResource = translator.translateOneToBackendModel(account);

    const result: Result<AccountBackend> = await persistence.create(
      backendResource,
    );
    loggingService.log(LogType.info, `Account: ${result.data.id} created.`);

    if (result.error) {
      loggingService.log(
        LogType.error,
        `Account: creation failed: ${result.error}`,
      );
      return onError(thunkAPI, result.error);
    }

    ReactGA.event({
      category: 'Account',
      action: 'Create',
    });

    // WARNING: don't use response in redux since onCreate will do this.
    return true;
  },
);

function onError(thunkAPI: any, error: Error) {
  return thunkAPI.rejectWithValue({
    heading: 'Unable to create account',
    message: error.message,
    severity: 'error',
    id: uuidv4(),
  });
}
